<template lang="pug">
#OVActions
  .actions-buttons
    b-dropdown(
      id="ov-actions"
      variant="primary"
      style="width: 130px"
      no-caret
      right
      v-if="auxOvActions && auxOvActions.visible.length > 0"
    )
      template(v-slot:button-content)
        span
          img(src="@/assets/icons/actions.svg" alt="Acciones" style="width: 23px; height: 23px; margin-right: 5px")
          b-spinner(v-if="loading" small)
          span(v-else) Acciones
      b-dropdown-item(
        :id="`ov-action-${action.actionCondition}`"
        v-for="action in actions"
        v-if="actionsToShow.includes(action.actionCondition) && loading === false"
        :key="action.actionCondition"
      )
        component(
          :is="action.component"
          :disabled="auxOvActions.disabled.includes(action.actionCondition)"
          :asButton="action.actionCondition === 'VerOvPrecompletada'"
          :dataOv="dataOv"
          :actionCondition="action.actionCondition"
          @reloadAll="$emit('reloadAll')"
        )
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import GenerarCotizacion from './Actions/GenerarCotizacion.vue'
import CompletarCotizacion from './Actions/CompletarCotizacion.vue'
import AceptarCotizacion from './Actions/AceptarCotizacion.vue'
import RechazarCotizacion from './Actions/RechazarCotizacion.vue'
import PedirRepuestosBodega from './Actions/PedirRepuestosBodega.vue'
import PrepararNuevaCotizacion from './Actions/PrepararNuevaCotizacion.vue'
import CerrarOVRechazado from './Actions/CerrarOVRechazado.vue'
import RepuestosRecibidosBodega from './Actions/RepuestosRecibidosBodega.vue'
import RepuestosRecibidosEjecutivo from './Actions/RepuestosRecibidosEjecutivo.vue'
import IrAOVRechazada from './Actions/IrAOVRechazada.vue'
import IngresarPago from './Actions/IngresarPago.vue'
import IndicarRMA from './Actions/IndicarRMA.vue'
import CrearOT from './Actions/CrearOT.vue'
import IngresarPagoEnOVRechazada from './Actions/IngresarPagoEnOVRechazada.vue'
import CompletarPrecompletada from './Actions/CompletarPrecompletada.vue'
import RevaluarOT from './Actions/RevaluarOT.vue'
import RecalcularPDF from './Actions/RecalcularPDF.vue'
import GarantiaReparacion from './Actions/GarantiaReparacion.vue'
import RevisarCotizacion from './Actions/RevisarCotizacion.vue'
import ReingresarEvaluacion from './Actions/ReingresarEvaluacion.vue'
import CambiarEnvio from './Actions/CambiarEnvio.vue'

export default {
  data() {
    return {
      loading: false,
      auxOvActions: null,
      actions: [
        {
          component: GenerarCotizacion,
          actionCondition: 'VerOvPrecompletada',
        },
        {
          component: RevisarCotizacion,
          actionCondition: 'RevisarCotizacion',
        },
        {
          component: CompletarPrecompletada,
          actionCondition: 'CompletarPrecompletada',
        },
        {
          component: CompletarCotizacion,
          actionCondition: 'CompletarCotizacion',
        },
        {
          component: AceptarCotizacion,
          actionCondition: 'AceptarCotizacion',
        },
        {
          component: RechazarCotizacion,
          actionCondition: 'RechazarCotizacion',
        },
        {
          component: PedirRepuestosBodega,
          actionCondition: 'PedirRepuestosBodega',
        },
        {
          component: PrepararNuevaCotizacion,
          actionCondition: 'PrepararNuevaCotizacion',
        },
        {
          component: CerrarOVRechazado,
          actionCondition: 'CerrarOVRechazado',
        },
        {
          component: RepuestosRecibidosBodega,
          actionCondition: 'RepuestosRecibidosBodega',
        },
        {
          component: CambiarEnvio,
          actionCondition: 'CambiarEnvio',
        },
        {
          component: RepuestosRecibidosEjecutivo,
          actionCondition: 'RepuestosRecibidosEjecutivo',
        },
        {
          component: IngresarPago,
          actionCondition: 'IngresarPago',
        },
        {
          component: IngresarPagoEnOVRechazada,
          actionCondition: 'IngresarPagoEnOVRechazada',
        },
        {
          component: IndicarRMA,
          actionCondition: 'IndicarRMA',
        },
        {
          component: IndicarRMA,
          actionCondition: 'IngresarRMA',
        },
        {
          component: IrAOVRechazada,
          actionCondition: 'IrAOVRechazada',
        },
        {
          component: CrearOT,
          actionCondition: 'CrearOT',
        },
        {
          component: RevaluarOT,
          actionCondition: 'RevaluarOT',
        },
        {
          component: RecalcularPDF,
          actionCondition: 'RecalcularPDF',
        },
        {
          component: GarantiaReparacion,
          actionCondition: 'SolicitudExcepcionGarantia',
        },
        {
          component: ReingresarEvaluacion,
          actionCondition: 'ReingresarEvaluacion',
        },
      ],
    }
  },
  props: {
    ovId: {
      type: Number,
      required: true,
    },
    dataOv: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions('OVStore', ['listOvActions']),
    async reloadActions(
      hasResponse = false,
      messageTitle = null,
      message = null,
      messageVariant = null
    ) {
      this.loading = true
      await this.listOvActions(this.ovId)
      this.auxOvActions = { ...this.ovActions }
      this.loading = false
      // Funcionalidad para la respuesta de las acciones
      if (hasResponse) {
        this.$bvToast.toast(message, {
          title: messageTitle,
          variant: messageVariant,
          solid: true,
        })
      }
    },
    reloadAll() {
      this.reloadActions()
    },
  },
  computed: {
    ...mapGetters('OVStore', ['ovActions']),
    actionsToShow() {
      return [...this.auxOvActions.visible, ...this.auxOvActions.disabled]
    },
  },
  created() {
    this.reloadActions()
  },
}
</script>
<style lang="scss" scoped>
@import url('./Styles/Index.scss');
</style>
<style lang="scss">
#OVActions {
  .actions-buttons {
    .dropdown-item,
    .dropdown-menu.show {
      padding: 0px !important;
    }
    .dropdown-item:active,
    .dropdown-item:focus,
    .dropdown-item.focus {
      background-color: #cdcdcd !important;
    }
    // Centrar y estilizar botones dentro del dropdown
    .dropdown-item {
      display: flex;
      justify-content: center;
      align-items: center;

      .btn {
        width: 100%;
        margin: 0;
        border-radius: 0;
      }
    }
  }
}
</style>
